import { NgModule } from '@angular/core';
import { CoreUiModule } from 'webcommon/core-ui';
import { MacroModule } from 'webcommon/macro';

import {
  ApHtmlTextEditorComponent,
} from './html-text-editor';

import {
  ApHtmlTextEditorWithMacrosComponent,
} from './html-text-editor-with-macros';

import {
  ApHtmlMacrosEditorComponent,
} from './components';
import { ApSingleFieldAdvancedEditorModalComponent } from './ap-single-field-advanced-editor';


const exportComponents = [
  ApHtmlTextEditorComponent,
  ApHtmlTextEditorWithMacrosComponent,
  ApHtmlMacrosEditorComponent,
  ApSingleFieldAdvancedEditorModalComponent,
];

const declareComponents = [
  ...exportComponents,
];

@NgModule({
  declarations: [
    declareComponents,
  ],
  exports: [
    exportComponents,
  ],
  imports: [
    CoreUiModule,
    MacroModule,
  ],
})
export class HtmlEditorModule {
}
